var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "feature-flags-page",
      staticStyle: { margin: "90px" },
    },
    [
      _c(
        "el-header",
        { staticStyle: { height: "100px", "margin-top": "20px" } },
        [
          _c(
            "span",
            {
              staticClass: "ring-card__header-buttons",
              staticStyle: { margin: "0px 0px 20px 0px", float: "right" },
            },
            [
              _c("RefreshButton", {
                nativeOn: {
                  click: function ($event) {
                    return _vm.refresh(true)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "center", color: "#1998d5" } },
            [_c("h2", [_vm._v("Manage Feature Flags")])]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { height: "50px" } },
        [
          _c(
            "el-tooltip",
            { attrs: { content: "Create Feature-Flag" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { float: "right", "font-size": "14px" },
                  attrs: { size: "medium", type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.openCreateFFDialog()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _vm._v("\n        Create\n      "),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-input",
            {
              staticStyle: {
                "font-size": "14px",
                margin: "0px 10px 20px 0px",
                float: "right",
                width: "300px",
              },
              attrs: {
                placeholder: "Find by Key, Name or Description",
                clearable: "",
                type: "text",
              },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            },
            [
              _c("i", {
                staticClass: "el-input__icon el-icon-search",
                attrs: { slot: "prefix" },
                slot: "prefix",
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.FeatureFlagsList },
        },
        [
          _c("el-table-column", {
            attrs: { label: "Key", prop: "key" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (featureFlagItem) {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(featureFlagItem.row.key) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { label: "id", prop: "id" } }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Name", prop: "name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (featureFlagItem) {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(featureFlagItem.row.name) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Description", prop: "description" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (featureFlagItem) {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(featureFlagItem.row.description) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (featureFlagItem) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Cannot update an active feature-flag",
                          placement: "top",
                          disabled: !featureFlagItem.row.active,
                        },
                      },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            size: "mini",
                            icon: "el-icon-edit",
                            disabled: featureFlagItem.row.active,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openUpdateFFDialog(featureFlagItem.row)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Cannot delete an active feature-flag",
                          placement: "top",
                          disabled: !featureFlagItem.row.active,
                        },
                      },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            icon: "el-icon-delete",
                            disabled: featureFlagItem.row.active,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openDeleteFFDialog(featureFlagItem.row)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-switch", {
                      staticStyle: { margin: "5px 5px 0px 10px" },
                      on: {
                        change: function ($event) {
                          return _vm.updateFeatureFlag(
                            featureFlagItem.row,
                            false
                          )
                        },
                      },
                      model: {
                        value: featureFlagItem.row.active,
                        callback: function ($$v) {
                          _vm.$set(featureFlagItem.row, "active", $$v)
                        },
                        expression: "featureFlagItem.row.active",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogDeleteFFVisible,
            width: "30%",
            "show-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogDeleteFFVisible = $event
            },
          },
        },
        [
          _c("span", { staticStyle: { "margin-left": "40px" } }, [
            _c("img", {
              staticClass: "icon",
              attrs: { src: _vm.icons.warning },
            }),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "dialog_title_style" }, [
            _vm._v("\n      Delete this Feature-Flag?\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { padding: "30px" } }, [
            _c("div", { staticClass: "dialog_item_style" }, [
              _c("span", { staticStyle: { "margin-right": "40px" } }, [
                _vm._v("Key:"),
              ]),
              _c("b", [_vm._v(_vm._s(_vm.featureFlag.key) + " ")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dialog_item_style" }, [
              _c("span", { staticStyle: { "margin-right": "20px" } }, [
                _vm._v("Name:"),
              ]),
              _c("b", [_vm._v(_vm._s(_vm.featureFlag.name))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dialog_item_style" }, [
              _c("span", { staticStyle: { "margin-right": "40px" } }, [
                _vm._v("Description:"),
              ]),
              _c("b", [_vm._v(_vm._s(_vm.featureFlag.description) + " ")]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogDeleteFFVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteFeatureFlag(_vm.featureFlag.id)
                    },
                  },
                },
                [_vm._v("Confirm")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogCreateFFVisible,
            width: "30%",
            "show-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogCreateFFVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog_title_style" }, [
            _vm._v("\n      Create Feature Flag\n    "),
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "dialog_create_form_style",
              attrs: {
                model: _vm.featureFlagForm,
                disabled: !_vm.featureFlagForm.resource,
              },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.createFeatureFlag(_vm.featureFlagForm)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialog_create_item_style" },
                [
                  _c("div", { staticClass: "dialog_create_item_title_style" }, [
                    _vm._v("\n          Key:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "custom-placeholder",
                    staticStyle: { "max-width": "400px" },
                    attrs: {
                      required: "",
                      placeholder: "Key",
                      input: "string",
                    },
                    model: {
                      value: _vm.featureFlagForm.key,
                      callback: function ($$v) {
                        _vm.$set(_vm.featureFlagForm, "key", $$v)
                      },
                      expression: "featureFlagForm.key",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog_create_item_style" },
                [
                  _c("div", { staticClass: "dialog_create_item_title_style" }, [
                    _vm._v("\n          Name:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "custom-placeholder",
                    staticStyle: { "max-width": "400px" },
                    attrs: {
                      required: "",
                      placeholder: "Name",
                      input: "string",
                    },
                    model: {
                      value: _vm.featureFlagForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.featureFlagForm, "name", $$v)
                      },
                      expression: "featureFlagForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog_create_item_style" },
                [
                  _c("div", { staticClass: "dialog_create_item_title_style" }, [
                    _vm._v("\n          Description:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "custom-placeholder",
                    staticStyle: { "max-width": "400px" },
                    attrs: {
                      required: "",
                      placeholder: "Detail the Feature flag purpose",
                      input: "string",
                    },
                    model: {
                      value: _vm.featureFlagForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.featureFlagForm, "description", $$v)
                      },
                      expression: "featureFlagForm.description",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog_create_item_style" },
                [
                  _vm._v("\n        Enabled:\n        "),
                  _c("el-switch", {
                    staticStyle: { margin: "5px 40px 0px 10px" },
                    model: {
                      value: _vm.featureFlagForm.active,
                      callback: function ($$v) {
                        _vm.$set(_vm.featureFlagForm, "active", $$v)
                      },
                      expression: "featureFlagForm.active",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogCreateFFVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled:
                      !_vm.featureFlagForm.key ||
                      !_vm.featureFlagForm.name ||
                      !_vm.featureFlagForm.description,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.createFeatureFlag(_vm.featureFlagForm)
                    },
                  },
                },
                [_vm._v("Create")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogUpdateFFVisible,
            width: "30%",
            "show-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUpdateFFVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog_title_style" }, [
            _vm._v("\n      Update Feature Flag\n    "),
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              ref: "ruleForm",
              staticClass: "dialog_create_form_style",
              attrs: {
                model: _vm.featureFlagForm,
                disabled: !_vm.featureFlagForm.resource,
              },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.updateFeatureFlag(_vm.featureFlagForm, true)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialog_create_item_style" },
                [
                  _c("div", { staticClass: "dialog_create_item_title_style" }, [
                    _vm._v("\n          Key:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "custom-placeholder",
                    staticStyle: { "max-width": "400px" },
                    attrs: {
                      required: "",
                      placeholder: "Key",
                      input: "string",
                    },
                    model: {
                      value: _vm.featureFlagForm.key,
                      callback: function ($$v) {
                        _vm.$set(_vm.featureFlagForm, "key", $$v)
                      },
                      expression: "featureFlagForm.key",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog_create_item_style" },
                [
                  _c("div", { staticClass: "dialog_create_item_title_style" }, [
                    _vm._v("\n          Name:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "custom-placeholder",
                    staticStyle: { "max-width": "400px" },
                    attrs: {
                      required: "",
                      placeholder: "Name",
                      input: "string",
                    },
                    model: {
                      value: _vm.featureFlagForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.featureFlagForm, "name", $$v)
                      },
                      expression: "featureFlagForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog_create_item_style" },
                [
                  _c("div", { staticClass: "dialog_create_item_title_style" }, [
                    _vm._v("\n          Description:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "custom-placeholder",
                    staticStyle: { "max-width": "400px" },
                    attrs: { required: "", input: "string" },
                    model: {
                      value: _vm.featureFlagForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.featureFlagForm, "description", $$v)
                      },
                      expression: "featureFlagForm.description",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog_create_item_style" },
                [
                  _vm._v("\n        Enabled:\n        "),
                  _c("el-switch", {
                    staticStyle: { margin: "5px 40px 0px 10px" },
                    model: {
                      value: _vm.featureFlagForm.active,
                      callback: function ($$v) {
                        _vm.$set(_vm.featureFlagForm, "active", $$v)
                      },
                      expression: "featureFlagForm.active",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogUpdateFFVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled:
                      !_vm.featureFlagForm.key ||
                      !_vm.featureFlagForm.name ||
                      !_vm.featureFlagForm.description,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.updateFeatureFlag(_vm.featureFlagForm, true)
                    },
                  },
                },
                [_vm._v("Update")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }